import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Patterns } from "../../shared/enums/patterns";
import { Component, Inject, OnInit } from '@angular/core';
import { NewUserTo } from '../../shared/models/newUserTo';
import { HomeService } from '../../home/home.service';
import { UsersService } from '../users.service';
import {OrganizationsService} from '../../organizations/organizations.service';
import { SharedService } from '../../shared/shared.service';
import { Alerts } from '../../shared/enums/alerts';
import { ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {Roles} from '../../shared/enums/roles';
import {
    SimpleListOrganizationsComponent
} from "../../organizations/simple-list-organizations/simple-list-organizations.component";
import {DialogService} from '../dialog.service';

@Component({
    selector: 'app-update-provision-user',
    templateUrl: './update-provision-user.component.html',
    styleUrls: ['./update-provision-user.component.scss']
})
export class UpdateProvisionUserComponent implements OnInit, AfterViewInit {
    @ViewChild('content') contentTemplate: TemplateRef<any>;
    @ViewChild('action') actionTemplate: TemplateRef<any>;

    readonly FIRSTNAME_MIN_LENGTH = 1;
    readonly FIRSTNAME_MAX_LENGTH = 50;
    readonly LASTNAME_MIN_LENGTH = 1;
    readonly LASTNAME_MAX_LENGTH = 50;
    readonly EMAIL_MIN_LENGTH = 8;
    readonly EMAIL_MAX_LENGTH = 60;

    resetData: NewUserTo;
    userData: NewUserTo;
    selectedOrgId: string;
    
    firstName = new UntypedFormControl('', [
        Validators.minLength(this.FIRSTNAME_MIN_LENGTH), Validators.maxLength(this.FIRSTNAME_MAX_LENGTH),
        Validators.pattern(Patterns.ALPHANUMERICPLUS)
    ]);
    lastName = new UntypedFormControl('', [
        Validators.minLength(this.LASTNAME_MIN_LENGTH), Validators.maxLength(this.LASTNAME_MAX_LENGTH),
        Validators.pattern(Patterns.ALPHANUMERICPLUS)
    ]);
    email = new UntypedFormControl('', [
        Validators.email,
        Validators.minLength(this.EMAIL_MIN_LENGTH), Validators.maxLength(this.EMAIL_MAX_LENGTH),
    ]);
    phone = new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(Patterns.PHONE)
    ]);
   
    psapId = new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(Patterns.ALPHANUMERICPLUS)
    ]);

    header: string;
    title: string;
    loading: boolean = false;
    fieldcheck: boolean = false;
    count: number = 1;
    userRole = []; 
      
    
    readonly EMAIL = 'email';
    readonly FIRSTNAME = 'firstName';
    readonly LASTNAME = 'lastName';
    readonly ROLES = 'roles';
    readonly PHONE = 'phone';
    readonly PSAP_ID = 'psapId';
    readonly roles = Roles;
    
    
    private updateProvisionUserOrgDialogRef: MatDialogRef<SimpleListOrganizationsComponent>;

    constructor(@Inject(MAT_DIALOG_DATA) public data: NewUserTo,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<UpdateProvisionUserComponent>,
        public userService: UsersService,
        public homeService: HomeService,
        public sharedService: SharedService,
        public orgService: OrganizationsService,
        private dialogService: DialogService
        ) {}

    ngOnInit() {
        console.log('UpdateProvisionUserComponent ngOnInit - data:', this.data);
        this.userData = new NewUserTo(this.data);
        this.resetData = new NewUserTo(this.data);
        this.header = 'Update Provisional User';
        this.title = this?.userData?.email;
        this.userRole = this.homeService.userDetails.roles.slice();
        console.log('User roles:', this.userRole);

        console.log('UpdateProvisionUserComponent - userData:', this.userData);
        console.log('UpdateProvisionUserComponent - header:', this.header);
        console.log('UpdateProvisionUserComponent - title:', this.title);


        // Set form control values
        this.email.setValue(this.userData.email);
        this.firstName.setValue(this.userData.firstName);
        this.lastName.setValue(this.userData.lastName);
        this.phone.setValue(this.userData.phone);
        this.psapId.setValue(this.userData.psapId);
    }
 

    ngAfterViewInit() {
        console.log('Content template:', this.contentTemplate);
        console.log('Action template:', this.actionTemplate);
        console.log('Header:', this.header);
        console.log('Title:', this.title);
        console.log('Loading:', this.loading);
    }

    isValidData() {
        this.markFormControlsAsTouched();
        return this.firstName.valid && this.lastName.valid &&
            this.phone.valid && this.psapId.valid;
    }

    updateProvisionalUser() {
        if (this.isValidData()) {
            if (this.resetData.firstName !== this.userData.firstName ||
                this.resetData.lastName !== this.userData.lastName ||
                this.resetData.phone !== this.userData.phone ||
                this.resetData.psapId !== this.userData.psapId) {
                this.loading = true;

                this.userService.updatedProvisionalUser(this.userData.id,this.userData).subscribe({
                    next: data => {
                        this.loading = false;
                        if (!data) {
                            this.sharedService.showAlert(Alerts.ERROR, 'Unprovisioned User update failed. Verify the details and try again.');
                        }else {
                            this.sharedService.showAlert(Alerts.SUCCESS, "Provisional User updated successfully.");
                            this.dialogRef.close(data);
                        }
                    },
                    error: error => {
                        this.loading = false;
                        this.sharedService.handleErrors(error,
                            [{
                                "condition": (error.status === 400 && Object.keys(error.error).length > 0),
                                "msg": error.error[Object.keys(error.error)[0]]
                            }],
                            "Unable to update user");
                    },
                    complete: () => { }
                });
            } else {
                this.sharedService.showAlert(Alerts.ERROR, 'Please modify the details to update');
                this.markFormControlsAsTouched();
            }
        } else {
            this.sharedService.showAlert(Alerts.ERROR, 'Please provide the correct details to update');
            this.markFormControlsAsTouched();
        }

    }

    resetUser() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.userData = new NewUserTo(this.resetData);
                }
            });
        } else {
            this.userData = new NewUserTo(this.resetData);
        }
    }

    close() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }

    getErrorMessage(formControl) {
        if (formControl === this.EMAIL) {
            return this.email.hasError('required') ? 'You must enter a value' :
                this.email.hasError('email') ? 'Not a valid email' : 'Email must be between 8 and 60 characters';
        } else if (formControl === this.FIRSTNAME) {
            return (this.firstName.hasError('required') && (this.firstName.touched || this.firstName.dirty)) ?
                'You must enter a value' : 'Enter a valid firstname (1-50 characters)';
        } else if (formControl === this.LASTNAME) {
            return this.lastName.hasError('required') ? 'You must enter a value' : 'Enter a valid lastname (1-50 characters)';
        } else if (formControl === this.PHONE) {
            return this.phone.hasError('required') ? 'You must enter a phone number ' : 'Enter a valid phone number';
        } else if (formControl === this.PSAP_ID) {
            return this.psapId.hasError('required') ? 'You must enter a PSAP ID ' : 'Enter a valid PSAP ID';
        }
    }

    change(event) {
        if (event) {
            if (event.srcElement.value !== '') {
                this.count = this.count + 1;
            } else if (event.srcElement.value === '') {
                this.count = this.count - 1;
            }
        }
        if (this.count <= 1 || this.fieldcheck === false) {
            this.fieldcheck = !this.fieldcheck;
        }
    }

    markFormControlsAsTouched() {
        this.firstName.markAsTouched();
        this.lastName.markAsTouched();
        this.email.markAsTouched();
        this.phone.markAsTouched();
        this.psapId.markAsTouched();
    }

    selectOrg(event?: Event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        
        // Close any existing dialog
        if (this.updateProvisionUserOrgDialogRef) {
            this.updateProvisionUserOrgDialogRef.close();
        }
        
        // Use the service method with component context
        this.updateProvisionUserOrgDialogRef = this.dialogService.openOrganizationDialog(
            this.dialog, 
            this.psapId.value, 
            'update-provision-user'
        );
        
        this.updateProvisionUserOrgDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.updateSelectedOrganization(result);
            }
            this.updateProvisionUserOrgDialogRef = null;
        });
    }

    private updateSelectedOrganization(result: any) {
        this.psapId.setValue(result);
        this.fieldcheck = true; // Mark as changed
    }


}
